<template>
    <div v-if="isBase">
        <v-card class="pa-8">
            <v-row>
                <v-col cols="12">
                    <h2>vla.tipsヘルプ</h2>
                </v-col>
                <v-col
                    v-for="(value, key) in contents" :key="key" cols="12" md="6"
                >
                    <h4>{{value.itemTitle}}</h4>
                    <ul>
                        <li v-for="(link, key) in value.itemlinks" :key="key">
                            <router-link :to="link.path">{{link.title}}</router-link>
                        </li>
                    </ul>
                </v-col>
            </v-row>
        </v-card>
    </div>
    <div v-else>
        <v-card class="pa-8">
            <h2>vla.tipsヘルプ</h2>
            <v-card-title>
                {{reference.title}}
            </v-card-title>
            <p v-if="reference.image !== undefined"><v-img :src="reference.image"></v-img></p>
            <v-card-text style="white-space: pre-wrap;">
                {{reference.content}}
            </v-card-text>
        </v-card>
        <v-card class="pa-8 mt-8">
            <v-card-title>
                課題が解決しなかった場合...
            </v-card-title>
            <v-card-text style="white-space: pre-wrap;">
                このヘルプや参考ページをご覧いただいても解決しなかった場合、<router-link to="/inquiry">お問い合わせフォーム</router-link>よりリクエストを送信ください。
            </v-card-text>
        </v-card>
        <v-card class="pa-8 mt-8">
             <v-card-title>
                関連記事
            </v-card-title>
            <ul>
                <li v-for="(value, key) in references" :key="key">
                    <router-link :to="value.path">{{value.title}}</router-link>
                </li>
            </ul>
            <a href="/help">ヘルプ一覧へ</a>
        </v-card>
    </div>
</template>
<script>
export default {
    name: 'BaseHelp',
    data() {
        return {
            isBase: false,
            reference: null,
            references: null,
            contents: [
                {
                    itemTitle: "vla.tipsとは",
                    itemlinks: [
                        {
                            title: "vla.tipsについて",
                            path: "/help/article",
                            content: "vla.tips(ヴィラ・チップス)は、エンジニアに長年参考にされている良質な記事(URL)を一つのURLにまとめ、世間に配信することができるキュレーションサイトです。"
                        },
                        {
                            title: "vla.tips誕生の経緯",
                            path: "/help/history",
                            content: "エラー解消の手助けや環境構築手順など、他の人にURL共有する場合、\nチャットサービスでURLを共有することがほとんどだと思いますが、\nその際にチャットが大量のURLで埋まってしまい、「過去をさかのぼるのが大変」「あのサイトどこだっけ？」「一箇所にまとまっていれば便利なのに」と思うまたは体験したことはあるあるではないでしょうか。\nvla.tipsを作ったきっかけは、自身がプログラミング指導、エンジニアのフォローアップをやっていてエンジニア対して大量のURLを共有することが多く、URLを共有する側もされる側も同じような体験をしてしまうと思ったことがきっかけです。"
                        },
                        {
                            title: "vla.tipsのサービス名の由来",
                            path: "/help/origin",
                            content: "ヘブライ語で「善悪の知識の木」は  \n「エツ・ハ = ダアト・トーヴ・ヴィラ」という。\n日本語で「善悪」と訳されているのが「ヴィラ」であるが、この「ヴィラ」は「善悪」のほかに「全てのもの」という意味もある。\ntips(チップス)とは、コツや秘訣、裏技、アドバイスを意味する言葉。\n「ヴィラ・チップス」はそれを掛け合わせた名前です。"
                        },
                    ]
                },
                {
                    itemTitle: "ガイドライン",
                    itemlinks: [
                        {
                            title: "良いトピックを書くためのガイドライン",
                            path: "/help/guideline",
                            content: "#### ガイドラインについて\nvla.tipsでまとめた記事(以下：トピック)は他のユーザーが参考にすることになります。\nあなたが書いたトピックが読んでくれた人の役に立つかを意識してみましょう。\n自分が参考にしたサイトを順番通りにまとめておいたものでも、少し丁寧にまとめておくだけで、\nとても価値のあるトピックを作成することができます。\n## 意識すると望ましいもの\nトピックのタイトルは記事のページではなくvla.tipsのフィードやGoogleの検索結果にも表示されます。\nタイトルを見ただけで、課題を解決したい人が読みたいと思うようなタイトル名をつけましょう。\n具体的なタイトルよりももっと大枠でざっくりとした名前をつけることで、用語がわからない勉学者でもトピックを見つけやすくなります。\n(例)\nJWTを使ってTokenを生成する方法→PHPで認証機能を作成\nreを使って正規表現を行う→Pythonで正規表現\nAWS上に独立した仮想プライベートネットワーク環境→AWS環境構築\n## 記事を書く上で気をつけること\nどんなに役立つ記事でも、最低限ルールを守らないといけません。\n#### 著作権に気をつける\n#### ライセンスや秘密保持契約に気を付ける\n#### 利用規約を守る"
                        },
                    ]
                },
                {
                    itemTitle: "設定ページでできること",
                    itemlinks: [
                        {
                            title: "アイコン画像の設定",
                            path: "/help/setting/icon",
                            content: "1. ヘッダーメニューから「マイページ」にアクセスし、ユーザーサイドメニュー「プロフィール編集」→「基本情報」→「アイコンを変更する」をクリックします。\n2. ファイルを選択をクリックし、画像ファイルを選択する\n3. トリミングができるので、自身でサイズを設定し'トリミング'をクリックする\n4. プロフィール編集画面下の「変更する」ボタンをクリックする"
                        },
                        {
                            title: "プロフィール情報の設定",
                            path: "/help/setting/profile",
                            content: "1. ヘッダーメニューから「マイページ」にアクセスし、ユーザーサイドメニュー「プロフィール編集」→「基本情報」をクリックします。\n2. 変更したい項目を入力する\n3. プロフィール編集画面下の「変更する」ボタンをクリックする"
                        },
                        {
                            title: "メールアドレスの変更",
                            path: "/help/setting/email",
                            content: "1. ヘッダーメニューから「マイページ」にアクセスし、ユーザーサイドメニュー「プロフィール編集」→「アカウント設定」をクリックします。\n2. メールアドレスの入力箇所を変更する\n3. 「メールアドレスを変更する」ボタンをクリックする"
                        },
                        {
                            title: "パスワードの変更",
                            path: "/help/setting/password",
                            content: "1. ヘッダーメニューから「マイページ」にアクセスし、ユーザーサイドメニュー「プロフィール編集」→「アカウント設定」をクリックします。\n2. 現在のパスワード欄に現在パスワードを入力する\n3. 新しいパスワード欄に新しいパスワードを入力する\n4. 新しいパスワード(再入力)欄に新しいパスワードを入力する\n5. 「パスワードを変更する」ボタンをクリックする"
                        },
                        {
                            title: "PRの設定",
                            path: "/help/setting/pr",
                            content: "1. ヘッダーメニューから「マイページ」にアクセスし、ユーザーサイドメニュー「プロフィール編集」→「ユーザーPR設定」をクリックします。\n2. 自身の性格を選択し、5段階評価で数値を変更する\n3. 自身の得意とするスキルを選択し、%評価で数値を変更する\n4. 自身の得意とするツールを選択し、合計100%となるように数値を変更する\n5. PR設定画面下の「変更する」ボタンをクリックする"
                        },
                        {
                            title: "Twitter、Github等SNSアカウントとの連携",
                            path: "/help/setting/account-link",
                            content: "1. ヘッダーメニューから「マイページ」にアクセスし、ユーザーサイドメニュー「プロフィール編集」→「外部リンク」をクリックします。\n2. 自身のGithubアカウントURLを入力する\n3. 自身のTwitterアカウントURLを入力する\n4. 自身のその他のリンクを入力する\n5. 外部リンク画面下の「変更する」ボタンをクリックする"
                        },
                        {
                            title: "退会方法",
                            path: "/help/setting/account-leave",
                            content: "1. ヘッダーメニューから「マイページ」にアクセスし、ユーザーサイドメニュー「プロフィール編集」→「アカウント削除」をクリックします。\n2. アカウント削除画面下の「削除する」ボタンをクリックする"
                        },
                    ]
                },
                {
                    itemTitle: "機能",
                    itemlinks: [
                        {
                            title: "会員登録するとできること",
                            path: "/help/function/member",
                            content: '・トピックの作成\n・お気に入りユーザーの登録\n・お気に入りトピックの登録\n・プロフィール画面で自身のスキルをPRすることができる\n・通知機能やお知らせを受け取ることができる'
                        },
                        {
                            title: "お気に入りユーザーを登録できる",
                            path: "/help/function/favorite/member",
                            content: "よく参考にするトピックを作成してくれる人や、知り合いのエンジニアを登録することができます。\n登録したユーザーは後から一覧で確認することもできるようになっています。",
                        },
                        {
                            title: "お気に入りトピックを登録できる",
                            path: "/help/function/favorite/topic",
                            content: "良質なトピックを登録することができます。\n録したトピックは後から一覧で確認することもできるようになっています。",
                        },
                        {
                            title: "トピックの作成",
                            path: "/help/function/topic",
                            content: "参考にした記事や、自身のブックマーク、エンジニアに関わる情報のトピックを作成することができます。",
                        },
                        {
                            title: "トピックやタグの検索",
                            path: "/help/function/search",
                            content: "ヘッダーにある検索窓から、トピックを検索することができます。\n部分一致で検索をかけられるので、用語がわからなくても多少の言葉で検索をかけることができます。",
                        },
                        {
                            title: "通知機能",
                            path: "/help/function/notification",
                            content: "管理者からお知らせや、トピックの編集権限のリクエスト、お気に入りユーザーの投稿、\nトピックパーツのサイトが無効(サイト閉鎖)になったらベルマークアイコンで通知を受け取ることができます。",
                        },
                        {
                            title: "ランキング機能(コントリビューター、タグ、利用URL)",
                            path: "/help/function/ranking",
                            content: "トピックを公開した際に、ランキングの対象となりトップページ左側のコントリビュータランキング、\nタグランキング、トピックパーツで利用しているURLのランキング対象となります。",
                        },
                        {
                            title: "PR機能",
                            path: "/help/function/pr",
                            content: "自分のスキルや得意な言語を設定し、自身のプロフィール(スキルセット)で他の人と差別化を図ることができます。",
                        },
                        {
                            title: "QR発行機能",
                            path: "/help/function/qr",
                            content: "トピックの共有はURLだけではなく、QRコードでも共有できるようになっています。\n閲覧中のトピックのQRコードをトピック詳細画面「QRコード」ボタンから発行することができます。",
                        },
                        {
                            title: "お問合せ機能",
                            path: "/help/function/notice",
                            content: "フッターのお問い合わせから、管理者に問い合わせをすることができます。\n「機能について」「導入について」「料金について」「その他」の項目でお問合せをしてください。",
                        },
                        {
                            title: "タグの設定",
                            path: "/help/function/tag",
                            content: "作成したトピックにタグを5つ設定することができます。\n設定したタグで検索ができたり、GoogleChromeの検索に引っかかりやすくなっていますので、\n設定を行うとよく参照されやすい記事を作成することができます。\n※協力のお願い\n現在利用できるタグは管理者側で追加を行なっています。\n追加したいタグがある場合はお問合せページからタグ名を入力しお問合せください。",
                        },
                    ]
                },
                {
                    itemTitle: "トピックの投稿",
                    itemlinks: [
                        {
                            title: "トピックについて",
                            path: "/help/topic/info",
                            content: "vla.tipsでのトピックとは、世の中の良質な記事(URL)をまとめた一つのURLをトピックと呼びます。",
                        },
                        {
                            title: "トピックパーツについて",
                            path: "/help/topic-parts/info",
                            content: "vla.tipsでのトピックパーツとは、世の中の良質な記事(URL)に関しての情報をトピックパーツと呼びます。\nトピックパーツには大きく分けて二種類あります。\n自身でエンジニアに役立つナレッジを書きたい場合はトピックパーツ説明欄にマークダウンで入力してください。\nトピックパーツURLをまとめる場合はトピックパーツ説明の入力は不要です。\n※どちらもトピックパーツURLは必須となっています。",
                        },
                        {
                            title: "トピック画像の変更",
                            path: "/help/topic/image",
                            content: "vla.tipsで作成したトピックにはトピック画像を設定することができます。\n1. トピック作成画面左下「画像を選択する」をクリックします。\n2. ファイルを選択をクリックし、画像ファイルを選択する。\n※注① 画像は著作権フリーの画像を利用してください。\n※注② 画像がない場合、vla.tipsのトピックテンプレート画像を加工してご利用ください。\n1. トピック作成画面左下「テンプレート画像ダウンロード」をクリックすると画像がダウンロードされます。\n2. 画像加工ソフト等で編集し、トピック画像として利用してください。",
                        },
                        {
                            title: "トピックの公開権限について",
                            path: "/help/topic/authority",
                            content: "まとめたトピックに対し公開範囲を決めることができます。プライベート、リンクを共有した人のみ閲覧可能、\n編集権限を付与した人と一緒に記事を作成したり、一般に公開することも可能になっています。",
                        },
                        {
                            title: "ブックマークのインポート",
                            path: "/help/topic/import",
                            content: "他サービスで既にブックマークしているサイトをトピックに書き出すことができます。",
                            image: require("@/assets/help/help2.png")
                        },
                        {
                            title: "ブックマークのエクスポート",
                            path: "/help/topic/export",
                            content: "自分でまとめたトピックをGoogleChromeのブックマーク形式でエクスポートができます。\nトピック画面「Export」ボタンをクリックすると、GoogleChromeのブックアーク形式HTMLファイルがダウンロードされます。",
                        },
                        {
                            title: "Markdown記法",
                            path: "/help/topic/markdown",
                            content: "トピックパーツタイトルは紫背景の黄色文字で画面上部に表示されます。\n1. 見出し1 「# 見出し1」シャープ1つを文字の頭に記述してください。\n2. 見出し2 「## 見出し2」シャープ2つを文字の頭に記述してください。\n3. 見出し3 「### 見出し3」シャープ3つを文字の頭に記述してください。\n4. 赤文字 「#### 見出し4」シャープ4つを文字の頭に記述してください。文字サイズは見出し2 のサイズとなります。\n5. 青文字 「##### 見出し5」シャープ5つを文字の頭に記述してください。文字サイズは見出し2 のサイズとなります。\n6. 緑文字 「###### 見出し6」シャープ6つを文字の頭に記述してください。文字サイズは見出し2 のサイズとなります。\n7. 太文字黄色マーカー「**太字**」太文字/黄色マーカーにしたい場合はアスタリスク2つを使って文字を囲ってください。\n8. 太文字水色マーカー「*斜体*」太文字/水色マーカーにしたい場合はアスタリスク1つを使って文字を囲ってください。\n9. 赤文字ピンク色アンダーライン 「~~取り消し線~~」赤文字/ピンク色アンダーラインにしたい場合は波線2つを使って文字を囲ってください。\n10. 黒文字ピンク色波ライン 「> 引用した文章はここに記入してください」黒文字/ピンク波ラインにしたい場合は大なり1つを文字の頭に記述してください。\n11. 数字リスト 「1. リスト 2. リスト..」数字リストにしたい場合は{数字. }数字とドットを文字の頭に記述してください。\n12. 点字リスト 「- リスト - リスト..」点字リストにしたい場合は{- }ハイフンを文字の頭に記述してください。\n13. コードブロック「``` コード ```」コードブロックしたい場合は{```}バッククォート3つを使って文字を囲ってください。\n14. コードスパン「` コード `」コードスパンしたい場合は{`}バッククォート1つを使って文字を囲ってください。\n15. リンク「[vla.tipsのリンク](https://vla.tips/)」リンクを設定したい場合は{[表示するタイトル](参考元のリンク)}ブラケットとパーレン使ってください。\n16. 表「| - | - | 」表を作成したい場合は{|}パイプラインを使ってください。",
                            image: require("@/assets/help/help3.png")
                        },
                        {
                            title: "編集権限のリクエスト",
                            path: "/help/topic/request",
                            content: "vla.tipsで作成したトピックには公開範囲を設定することができます。",
                        },
                        {
                            title: "トピックURLのコピー",
                            path: "/help/topic/copy",
                            content: "トピック画面上部の「コピー」ボタンをクリックすると、ダッシュボードにURLがコピーされます。\nトピックの共有を行いたい場合などにご利用ください。",
                        },
                        {
                            title: "トピックURLのQRコード発行",
                            path: "/help/topic/qr",
                            content: "トピック画面上部の「QRコード」ボタンをクリックすると、QRコードされます。\nトピックの共有を行いたい場合などにご利用ください。",
                        },
                        {
                            title: "無効になったURLについて",
                            path: "/help/topic/deadlink",
                            content: "vla.tipsではトピックを作成する段階で存在しないURLは投稿できないようになっています。\n参考となるサイトが閉鎖された場合などはURLが無効となり、無効となったURLはデットリンクと呼んでいます。\nURLが無効となった場合は通知機能によりトピックの作成者に通知を行うようになっています。",
                        },
                    ]
                },
                {
                    itemTitle: "認証等",
                    itemlinks: [
                        {
                            title: "OAuth認証について",
                            path: "/help/auth/oauth",
                            content: "vla.tipsではアカウントを登録する際に、Googleアカウント、Githubアカウントでの登録ができるようになっています。",
                        },
                        {
                            title: "メール認証について",
                            path: "/help/auth/email",
                            content: "vla.tipsで会員登録を行なった場合、確認用のメールを登録時のメールアドレスに送付させていただいております。\nメールを確認の上、添付されているURLをクリックをしていただくことで本会員登録とさせていただいております。",
                        },
                        {
                            title: "パスワードを忘れてしまった場合",
                            path: "/help/auth/password",
                            content: "vla.tipsではログイン時にパスワードを忘れてしまった場合、パスワードの再設定を行うことができます。\nご登録いただいた際のユーザーコードを入力するとご登録時のメールアドレスに再設定用のリンクを添付したメールをサービスから送信させていただいております。\nメールに添付されている再設定用のURLから再設定を行なってください。",
                        },
                        {
                            title: "SNSとの連携について",
                            path: "/help/auth/sns",
                            content: "vla.tipsでは良質なトピックをSNSで投稿することができます。\n投稿方法：\nトピックページ下に記載されている各SNSアイコン(Pinterest, Twitter, Line, Pocket, Facebook)より投稿することができます。",
                        },
                    ]
                },
            ],
        }
    },
    methods: {
        setContent() {
            let reference = this.contents.filter(function(content) {
                let marvelHeroes = content.itemlinks.filter(function(link) {
                    return link.path === this;
                }, this);
                if (marvelHeroes.length > 0) {
                    return marvelHeroes;
                }
            }, this.$route.path);
            this.references = reference[0].itemlinks;

            let contents = this.contents.map(function(content) {
                let marvelHeroes = content.itemlinks.filter(function(link) {
                    return link.path === this;
                }, this);
                if (marvelHeroes.length > 0) {
                    return marvelHeroes[0];
                }
            }, this.$route.path);
            let content = contents.filter(title => title !== undefined);
            this.reference = content[0];
        }
    },
    created() {
        if (this.$route.path === "/help" || this.$route.path === "/help/") {
            this.isBase = true;
        } else {
            this.setContent();
            this.isBase = false;
        }
    },
    watch: {
        async $route(to, from) {
            // ルートの変更の検知...
            if (to.params !== from.params) {
                await this.setContent();
                this.isBase = false;
            }
        }
  },

}
</script>
<style scoped>
>>>h2 {
    color: yellow;
    background: #5E00BC;
    /* padding: 16px 16px 16px 16px; */
    padding: 24px;
    font-weight: bold !important;
    border-radius: 5px;
}
>>>.v-card__title {
    font-weight: bold !important;
}
>>>h4 {
    font-weight: bold !important;
}
>>>a {
    color: black !important;
    font-weight: normal !important;
}
</style>